// extracted by mini-css-extract-plugin
export var completionBody = "_h4-2";
export var completionCard = "_h4-0";
export var completionFooter = "_h4-3";
export var completionTitle = "_h4-1";